import 'css-chunksrc/client/scenes/listRemoval/listsList/list/event/nameEditionForm/styles.scss';export default {
  "nameEditionForm": "_nameEditionForm_pupqt_1",
  "form": "_form_pupqt_6",
  "name": "_name_pupqt_1",
  "icon": "_icon_pupqt_26",
  "input": "_input_pupqt_30",
  "late": "_late_pupqt_51",
  "completed": "_completed_pupqt_58",
  "edition": "_edition_pupqt_65"
};